export default __webpack_public_path__ + "static/Efficiency-d518f08fc5279493a8ac4b0a825e25e9.png";